import { ArrangementResource } from '@thiememeulenhoff/types';
import { map, Observable } from 'rxjs';

export function sanitizeResources<T extends ArrangementResource>(
  resources: Array<T>,
): Array<T> {
  return resources.map((resource) => {
    if (resource.navigationMetadata) {
      return resource;
    }

    const result = { ...resource };
    result.navigationMetadata = {};
    return result;
  });
}

export function sanitizeResourcesOperator<T extends ArrangementResource>() {
  return (source: Observable<Array<T>>): Observable<Array<T>> =>
    source.pipe(map((resources) => sanitizeResources(resources)));
}
